export type TailwindBreakpoint = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

const isTailwindBreakpoint = (breakpoint: TailwindBreakpoint) => {
  const breakpoints = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
  };

  return window.matchMedia(`(min-width: ${breakpoints[breakpoint]}px)`).matches;
};

export default isTailwindBreakpoint;
